import ApiService from "../ApiService";
import { StorageService } from "../StorageService";

const vademecumService = {
    getVademecumOrder(data) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/asegurator-medicines/`,
            method: "get",
            data,
        });
    },
    createVademecun(data) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/asegurator-medicines/save/`,
            method: "post",
            data,
        });
    },
    createKardex(data) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/add-kardex/save_objet/`,
            method: "post",
            data,
        });
    },
    updateVademecun(id, data) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/asegurator-medicines/` + id,
            method: "put",
            data,
        });
    },
    deleteVademecun(formData) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/asegurator-medicines/` + formData,
            method: "delete",
        });
    },
};

export default vademecumService;